import { render } from "./AboutUsENG.vue?vue&type=template&id=7c85ee86&scoped=true"
import script from "./AboutUsENG.vue?vue&type=script&lang=js"
export * from "./AboutUsENG.vue?vue&type=script&lang=js"

import "./AboutUsENG.vue?vue&type=style&index=0&id=7c85ee86&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c85ee86"]])

export default __exports__